import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LogsPanelComponent } from '@shared/components/logs-panel/logs-panel.component';
import { LoggerService } from '@core/logging/logger.service';

@Component({
  selector: 'app-root',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, LogsPanelComponent],
  template: `
    <div class="app">
      <router-outlet />
      @if (showLogs) {
        <app-logs-panel />
      }
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        height: 100vh;
      }
      .app {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
      }
      router-outlet {
        flex: 1;
      }
      app-logs-panel {
        flex: 0 0 16rem;
        border-top: 1px solid #333;
        overflow: auto;
      }
    `,
  ],
})
export class AppComponent {
  private readonly logger = inject(LoggerService);

  /**
   * The log panel is opt-in via `?debug=1` (§9.2).
   *
   * On the patient's TV it would otherwise occupy a third of the screen during
   * a consultation, and its audience is whoever is diagnosing a fault — not the
   * clinician.
   */
  readonly showLogs = new URLSearchParams(window.location.search).has('debug');

  constructor() {
    this.logger.log('session', 'app.started');
  }
}
